import { PreziProjectType } from '__generated__/types';
import TextList from 'common/components/TextList';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    existingPreziUrls: string[];
    preziClassicUrls: string[];
}

interface Props<T> {
    form: ObservableForm<T>;
    projectType: string;
}

const PreziUrlsFields: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    projectType,
}) => {
    switch (projectType) {
        case PreziProjectType.EDIT_EXISTING_PREZI:
            return (
                <Field
                    form={form}
                    name="existingPreziUrls"
                    title={__('Link to any existing Prezi')}
                    required={true}
                    render={() => (
                        <TextList
                            {...form.attach('existingPreziUrls')}
                            placeholder="prezi.com/existing-prezi/"
                        />
                    )}
                />
            );
        case PreziProjectType.CONVERT_CLASSIC_TO_NEXT:
            return (
                <Field
                    form={form}
                    name="preziClassicUrls"
                    title={__('Link to any Prezi Classic')}
                    required={true}
                    render={() => (
                        <TextList
                            {...form.attach('preziClassicUrls')}
                            placeholder="prezi.com/prezi-classic/"
                        />
                    )}
                />
            );
        default:
            return <React.Fragment />;
    }
};

export default PreziUrlsFields;
